<span
  class="menuitems"
  [class]="{ hastext: hasDisplayText() }"
  (click)="this.emitClick.emit()"
>
  <ion-icon
    class="sidebar-icon"
    [class]="{ active: isActive }"
    [src]="icon()"
  />
  @if (hasDisplayText()) {
    <span class="main-label" [class]="{ active: isActive }">
      {{ displayText() }}
    </span>
  }
</span>
